import script from "./hotel-details.vue?vue&type=script&setup=true&lang=js"
export * from "./hotel-details.vue?vue&type=script&setup=true&lang=js"

import "./hotel-details.vue?vue&type=style&index=0&id=6b2d3745&lang=css"

const __exports__ = script;

export default __exports__